export default {
    SET_TOUR_GUIDES: "SET_TOUR_GUIDES",
    UPDATE_TOUR_GUIDE_SECTION: "UPDATE_TOUR_GUIDE_SECTION"
}